import { TextInput } from '@/components'
import { createStyles } from '@codeleap/styles'
import { PropsOf } from '@codeleap/types'

export type TimeInputProps = Partial<PropsOf<typeof TextInput>>

export const TimeInput = ({ label = 'Time', debugName, ...props }: TimeInputProps) => {

  return (
    <TextInput
      leftIcon={{ name: 'clock' }}
      label={label}
      debugName={debugName}
      {...props}
      style={['rightIcon:pointer', { input: styles.timeInput }, props?.style]}
      type='time'
    />
  )
}

const styles = createStyles(() => ({
  timeInput: {
    '&::-webkit-calendar-picker-indicator': {
      opacity: 0,
      cursor: 'pointer',
      width: '100%',
      height: '100%',
      position: 'absolute',
      left: 0,
      top: 0,
    },
    '&::-webkit-inner-spin-button': {
      display: 'none',
    },
    position: 'relative',
  },
}))
